import React, { useState, useEffect, useRef } from "react";

function HtmlContentLoader({ url, onAnchorClick }) {
  const [htmlContent, setHtmlContent] = useState("");
  const containerRef = useRef(null);

  useEffect(() => {
    if (!url) return;

    const fetchHtml = async () => {
      try {
        const response = await fetch(url);
        const html = await response.text();
        setHtmlContent(html);
      } catch (err) {
        console.error("Error loading HTML:", err);
      }
    };

    fetchHtml();
  }, [url]);

  useEffect(() => {
    if (!onAnchorClick || !htmlContent || !containerRef.current) return;

    const container = containerRef.current;

    const handleClick = (e) => {
      const anchor = e.target.closest("a");
      if (anchor && container.contains(anchor)) {
        e.preventDefault();
        if (onAnchorClick) {
          onAnchorClick(anchor.href);
        }
        window.open(anchor.href, "_blank", "noopener,noreferrer");
      }
    };

    container.addEventListener("click", handleClick);

    return () => {
      container.removeEventListener("click", handleClick);
    };
  }, [htmlContent, onAnchorClick]);

  return (
    <div
      ref={containerRef}
      className="norstella-pf-externalhtml-container"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

export default HtmlContentLoader;
